import { Landing } from "../../domain/landing/landing";
import { LandingActionTypes } from "../action-types";
import { LandingActions } from "../actions";
import produce from 'immer';


interface LandingState {
    loading: boolean | null;
    landings: Landing[] | null,
    error: string | null,
    entityLoading: boolean,
    entityError: string | null,
}

const initialState: LandingState = {
    loading: null,
    landings: null,
    error: null,
    entityLoading: false,
    entityError: null,
}



const reducer = produce((state: LandingState = initialState, action: LandingActions) => {
    switch (action.type) {
        case LandingActionTypes.LANDING_REQUEST_SEND:
            state.loading = true;
            return state;
        case LandingActionTypes.LANDING_SUCCESS:
            state.loading = false;
            state.landings = action.payload;
            return state;
        case LandingActionTypes.LANDING_ERROR:
            state.loading = false;
            state.error = action.payload;
            return state;
        case LandingActionTypes.LANDING_CREATE_REQUEST:
            state.entityLoading = true
            state.entityError = ""
            return state;
        case LandingActionTypes.LANDING_CREATE_SUCCESS:
            state.entityLoading = false
            state.landings!.push(action.payload)
            state.entityError = ""
            return state;
        case LandingActionTypes.LANDING_CREATE_ERROR:
            state.entityLoading = false
            state.entityError = action.payload;
            return state;
        case LandingActionTypes.LANDING_DELETE_SUCCESS:
            state.landings = state.landings!.filter((landings) => landings.Id() !== action.payload)
            return state;
        default:
            return state;
    }
})

export default reducer;
